<section class="section white-100" *ngIf="onboardingData">
  <div class="section-container">
    <div class="extensive-coverage-container grey-100">
      <div>
        <div class="product-blog-subheading mar-b-16">
          {{ onboardingData?.tagName }}
        </div>
        <div class="extensive-coverage-heading">
          {{ onboardingData?.title }}
        </div>
        <p class="product-blog-description mar-b-48">
          {{ onboardingData?.description }}
        </p>
        <div class="landing-btn">
          <a
            href="{{ onboardingData?.button.redirectLink }}"
            target="{{ onboardingData?.buttonactionType }}"
            class="btn btn-full"
          >
            {{ onboardingData?.button?.buttonText }}
          </a>
        </div>
      </div>
      <div class="international-business-blog">
        <img loading="lazy" [src]="onboardingData?.image" alt="" />
      </div>
    </div>
  </div>
</section>
